"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNursysLookupResultRecordedDto = instanceOfNursysLookupResultRecordedDto;
exports.NursysLookupResultRecordedDtoFromJSON = NursysLookupResultRecordedDtoFromJSON;
exports.NursysLookupResultRecordedDtoFromJSONTyped = NursysLookupResultRecordedDtoFromJSONTyped;
exports.NursysLookupResultRecordedDtoToJSON = NursysLookupResultRecordedDtoToJSON;
exports.NursysLookupResultRecordedDtoToJSONTyped = NursysLookupResultRecordedDtoToJSONTyped;
/**
 * Check if a given object implements the NursysLookupResultRecordedDto interface.
 */
function instanceOfNursysLookupResultRecordedDto(value) {
    if (!('recorded' in value) || value['recorded'] === undefined)
        return false;
    return true;
}
function NursysLookupResultRecordedDtoFromJSON(json) {
    return NursysLookupResultRecordedDtoFromJSONTyped(json, false);
}
function NursysLookupResultRecordedDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'recorded': json['recorded'],
    };
}
function NursysLookupResultRecordedDtoToJSON(json) {
    return NursysLookupResultRecordedDtoToJSONTyped(json, false);
}
function NursysLookupResultRecordedDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'recorded': value['recorded'],
    };
}
//# sourceMappingURL=NursysLookupResultRecordedDto.js.map